import { Component, OnInit } from '@angular/core';
import { HeaderService } from '../../services/header/header.service';
import { Observable } from 'rxjs';
import { Session } from '../../models/auth/session';
import { SessionService } from '../../services/auth/session.service';
import { SubSink } from 'subsink';
import { AppState, GlobalActions } from 'src/app/reducers';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { MessageBoxService } from 'src/app/core/services/message-box/message-box.service';
import { SwitchRolePopupComponent } from '../switch-role-popup/switch-role-popup.component';
import { SwitchRolePopupService } from '../../services/switch-role-popup.service';
@Component({
  selector: 'tcat-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {


  isShowingHeader$ = this.headerService.shouldShowHeader();
  session$?: Observable<Session>;
  session?: Session;
  subsink = new SubSink();
  constructor(private headerService: HeaderService,
    private sessionService: SessionService,
    private store: Store<AppState>,
    private router: Router,
    private messageBoxService: MessageBoxService,
    private switchRolePopup: SwitchRolePopupService
  ) { }

  ngOnInit(): void {
    this.subsink.sink = this.session$ = this.sessionService.session();
    this.session$.subscribe(session => {
      console.log("session", session);
      this.session = session;
    });
  }

  logout(event: any) {
    event.stopPropagation();
    this.store.dispatch(GlobalActions.logout());
    this.sessionService.clearSession();
    //this.sseService.unSubscribeFromStream();
    this.router.navigateByUrl('/auth/login');
  }

  switchRole(event: any) {

    this.switchRolePopup.showPopup()
      .then(changedRole => {
        this.messageBoxService.showMessage(
          'Switch Role',
          "Do you want to switch the user's role?",
          [{ id: 'yes', text: 'Yes' }, { id: 'no', text: 'No' }])
          .then(selectedOption => {
            if (selectedOption.id === 'yes') {
              this.headerService.switchRole(changedRole)
            }
          });
      });
  }

  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

}
